const tr = {
    inv: '盤點',
    trade: '交易',
    transfer: '調撥',
    temporary: '臨時',
    inbound: '入庫',
    outbound: '出庫',
    scanOrder: '掃描單',
    inputOrder: '輸入單',
    beConfirmed: '待確認',
    confirmed: '已確認',
    invInProgress: '盤點進行中',
    genertDifferences: '生成差異中',
    cpletDifIn: '完成差異入庫',
    cpletDifOut: '完成差異出庫',
    cplet: '已完成',
    inboundSuccess: '入庫成功',
    outboundSuccess: '出庫成功',
    conIn: '確定入庫',
    conOut: '確定出庫',
    perOutbound: '預出庫',
    normalType: "普通物料",
    completeType: "成品",
    wastedType: "廢棄料",
    tempType: "臨時(中轉)庫位",
    locationType: "庫位類型",
    outter: "外部庫位/海外庫位",
    productionType: "生產庫位",
    defectiveReturnType: "不良品退貨庫位",
    defectiveTempType: "不良品臨時庫位",
    locLocked: "庫位已鎖定/盤點中",
    preOutExsist: "庫位存在預出庫",
    locNull: "庫位不存在",
    proQtyFalse: "產品數量不匹配",
    calcErr: "計算訂單庫位異常",
    list: "歷史記錄",
    batchAdd: "入庫",
    adjust: "出庫",
    count: "盤點",
    batchNo: "批次號",
    opType: "操作類型",
    beforeCount: "變更前數量",
    changeCount: "變更數量",
    afterCount: "變更後數量",
    createdAt: "創建時間",
    inventoryType: "出入庫類型",
};

export default tr;